import { render, staticRenderFns } from "./role.vue?vue&type=template&id=2b5ed2bc&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"
import style0 from "./role.vue?vue&type=style&index=0&id=2b5ed2bc&prod&scoped=true&lang=css"
import style1 from "./role.vue?vue&type=style&index=1&id=2b5ed2bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5ed2bc",
  null
  
)

export default component.exports